import React from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Grid,
  LinearProgress,
  useTheme,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  IconButton,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import FlashOnOutlinedIcon from "@material-ui/icons/FlashOnOutlined";
import CloseIcon from "@material-ui/icons/Close";
import {
  useIVcurveView,
  useivnormalView,
  usePreviousProcedure,
  useView,
} from "../dataEgressQueries";
import {
  mutateCharts,
  useAddNoteToResult,
  useSelectedProcedureFlash,
  useUpdateFlag,
} from "../dataEgressMutations";
import { useFetchContext } from "../../common/FetchContext";
import { useAuthContext } from "../../common/AuthContext";
import { ErrorMessage } from "../../common/ErrorMessage";
import { ThreadedCreator } from "../../common/threadedViewer/threadedCreator";
import { useRetestProcedure, useReviewProcedure } from "../dataEgressMutations";
import { useDispositionsByName } from "../../common/services/dispositionServices";
import { useQueryClient } from "react-query";
import { processErrorOnMutation } from "../../../util/errorMessaging";
import { toast } from "react-toastify";
import { ConfirmationDialog } from "../../common/ConfirmationDialog";

import { IVCurve } from "./IVCurve";
import { Scatter } from "./IVScatter";
import { AssetNameViewer } from "../../common/AssetNameViewer";
import {
  useTestPermissions,
  useTestPermissionsVerification,
} from "../../projectManagement/projectQueries";
import { TravelerModalButton } from "../TravelerModalButton";
import { VisualizerNotesModal } from "../VisualizerNotesModal";
import { getTheme } from "../../common/getLocalTheme";
import { useSubmitProcedureResult } from "../../testCommunication/common/testMutations";
import MuiLink from "@material-ui/core/Link";

interface IVReviewModalProps {
  id?: any;
  disposition?: any;
  name?: any;
  dispositionPassedId?: any;
  open_notes?: any;
  has_notes?: any;
  isVerification?: any;
  travelerResults?: any;
  isComments?: boolean;
  onOpenNotes?: () => void;
  isCustomCurve?: boolean;
}

export const IVReviewModal = ({
  id,
  disposition,
  name,
  dispositionPassedId,
  open_notes,
  has_notes,
  isVerification,
  isComments,
  onOpenNotes,
  isCustomCurve,
}: IVReviewModalProps) => {
  const theme = useTheme();
  const history = useHistory();
  const queryClient = useQueryClient();
  const { dispatch } = useAuthContext();
  const { authAxios } = useFetchContext();
  const [open, setOpen] = React.useState(false);
  const [Pdfopen, setPdfOpen] = React.useState(false);
  const [charts, setCharts] = React.useState<any[]>([]);
  const { mutateAsync: mutateRetestProcedure } = useRetestProcedure();
  const { mutateAsync: mutateReviewProcedure } = useReviewProcedure();
  const { mutateAsync: mutateNote } = useAddNoteToResult();
  const [multiplier, setMultiplier] = React.useState(0);
  const [chartType, setChartType] = React.useState(1);

  const [confirmationDialogRetestOpen, setConfirmationDialogRetestOpen] =
    React.useState(false);
  const [confirmationDialogApproveOpen, setConfirmationDialogApproveOpen] =
    React.useState(false);

  const [ivchartType, setIvChartType] = React.useState("fitted_curve");
  const [viewErrorMessage, setViewErrorMessage] = React.useState("");

  const [flagChecked, setFlagCheck] = React.useState(false);
  const [flagDialog, setFlagDialog] = React.useState(false);
  const { mutateAsync: mutateUpdateFlag } = useUpdateFlag();

  const [preFlashValues, setFlashValues] = React.useState<{
    flash_values?: any;
  }>({});

  const [showRetestOnError, setShowRetestOnError] = React.useState(false);

  const IV_CHART = 1;
  const SCATTER_CHART = 2;
  const RAW_CHART = 3;
  const RAW_SCATTER = 4;

  const {
    data: normalviewData,
    error: errorView,
    isLoading: isLoadingView,
    isError: isErrorView,
    isSuccess: isSuccessView,
  } = useivnormalView(id, open, !isCustomCurve);

  const {
    data: customViewData,
    error: customErrorView,
    isLoading: isLoadingCustomView,
    isError: isErrorCustomView,
    isSuccess: isSuccessCustomView,
    isFetching: isFetchingCustomView,
  } = useIVcurveView(id, open && !!isCustomCurve, ivchartType);

  const {
    data: previousProcedure,
    error: errorpreviousProcedure,
    isLoading: isLoadingpreviousProcedure,
    isError: isErrorpreviousProcedure,
    isSuccess: isSuccesspreviousProcedure,
  } = usePreviousProcedure({ authAxios, procedure_id: id }, open);
  const { data: permission, isLoading: isLoadingPermission } =
    useTestPermissionsVerification(id, open);

  const {
    mutateAsync: mutateProcedure,
    error: errorProcedureSelected,
    isError: isErrorMutateProcedureSelected,
    isSuccess: isSuccessProcedureSelected,
    isLoading: isLoadingTransisLog,
  } = useSelectedProcedureFlash();

  const viewData = isCustomCurve ? customViewData : normalviewData;

  const isLoading = isCustomCurve ? isLoadingCustomView : isLoadingView;

  const isError = isCustomCurve ? isErrorCustomView : isErrorView;

  const isSuccess = isCustomCurve ? isSuccessCustomView : isSuccessView;

  React.useEffect(() => {
    if (viewData && viewData.iv_curves) {
      viewData.final_result ? setFlagCheck(true) : setFlagCheck(false);

      var tempCharts = mutateCharts({ curves: viewData.iv_curves });
      setCharts(tempCharts);
      console.log(charts);

      viewData.iv_curves[0].multiplier
        ? setMultiplier(viewData.iv_curves[0].multiplier)
        : setMultiplier(1);
    }
  }, [viewData, isSuccessView]);

  const renderChart = () => {
    if (isCustomCurve) {
      switch (ivchartType) {
        case "fitted_curve":
        
          return <IVCurve chart={charts} />;

        case "fitted_scatter":
        case "raw_scatter":
          return <Scatter chart={charts} />;

        default:
          return null;
      }
    }

    switch (chartType) {
      case IV_CHART:
        return <IVCurve chart={charts} />;

      case SCATTER_CHART:
        return <Scatter chart={charts} />;

      default:
        return null;
    }
  };

  const handleChartType = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string;

    if (isCustomCurve) {
      setIvChartType(value);
    } else {
      setChartType(Number(value));
    }
  };


  const fileName = viewData?.flash_pdf_name ?? "No File";
  const pdfUrl = viewData?.flash_pdf_path ?? "";

  const viewerUrl = pdfUrl
    ? `https://docs.google.com/gview?url=${encodeURIComponent(pdfUrl)}&embedded=true`
    : "";

  const handleDownload = () => {
    if (pdfUrl && fileName) {
      const a = document.createElement("a");
      a.href = pdfUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  React.useEffect(() => {
    if (isErrorView && errorView) {
      const errorMessage =
        (errorView as any)?.response?.data?.message ||
        "Failed to load IV curve view";

      setViewErrorMessage(errorMessage);
    }
  }, [isErrorView, errorView]);

  React.useEffect(() => {
    if (isErrorCustomView && customErrorView) {
      const errorMessage =
        (customErrorView as any)?.response?.data?.message ||
        "Failed to load IV curve view";

      setViewErrorMessage(errorMessage);
    }
  }, [isErrorCustomView, customErrorView]);

  if (isLoadingView || isLoadingPermission || isLoadingpreviousProcedure) {
    return (
      <div style={theme.containerMargin}>
        <Grid container direction="row" alignItems="center" spacing={4}>
          <Grid item xs={12}>
            <LinearProgress />
          </Grid>
        </Grid>
      </div>
    );
  }

  // if (isErrorView) {
  //   return <ErrorMessage error={errorView} />;
  // }

  const handleClose = () => {
    setOpen(!open);
    setViewErrorMessage("");
  };

  const deviation = (expected: number, result: number, multiplier: number) => {
    var temp = (result / multiplier / expected - 1) * 100;

    return temp.toFixed(2);
  };

  const deviationPreMeasurement = (
    expected: number,
    result: number,
    multiplier: number,
  ) => {
    var temp = (result / multiplier / expected - 1) * 100;

    return temp.toFixed(2);
  };

  const deviationforIVcurveRear = (
    scaledNameplate: number,
    measurement: number,
  ) => {
    if (
      scaledNameplate === 0 ||
      scaledNameplate == null ||
      measurement == null
    ) {
      return "N/A";
    }

    const value = ((measurement - scaledNameplate) / scaledNameplate) * 100;

    return value.toFixed(2);
  };

  const submitFlagUpdate = async () => {
    try {
      if (flagChecked) {
        await mutateUpdateFlag({
          authAxios,
          id: viewData.id,
          final_result: false,
        });
        setFlagCheck(false);
      } else {
        await mutateUpdateFlag({
          authAxios,
          id: viewData.id,
          final_result: true,
        });
        setFlagCheck(true);
      }
      toast.success("Request Submited Successfully");
      setFlagDialog(false);
      queryClient.invalidateQueries("travelerResults");
    } catch (error) {
      toast.error("Request Submition Failed");
      setFlagDialog(false);
    }
  };

  const submitVerification = async (result: boolean) => {
    if (result) {
      try {
        await mutateReviewProcedure({
          authAxios,
          disposition: dispositionPassedId,
          procedure_result: id,
        });
        toast.success("Flash Test Review Approved");
        setConfirmationDialogApproveOpen(false);
        setOpen(false);
        if (isVerification) {
          queryClient.invalidateQueries("procedure_results_verify");
        } else {
          queryClient.invalidateQueries("verify_data");
          queryClient.invalidateQueries("travelerResults");
        }
      } catch (error) {
        toast.error("Error while approving Flash Test");
        processErrorOnMutation(error, dispatch, history);
        setConfirmationDialogApproveOpen(false);
        setOpen(false);
        if (isVerification) {
          queryClient.invalidateQueries("procedure_results_verify");
        } else {
          queryClient.invalidateQueries("verify_data");
          queryClient.invalidateQueries("travelerResults");
        }
      }
    } else {
      try {
        await mutateRetestProcedure({
          authAxios,
          procedure_result: id,
        });
        toast.success("Flash Test Review was sent for retesting");
        setConfirmationDialogRetestOpen(false);
        setOpen(false);
        if (isVerification) {
          queryClient.invalidateQueries("procedure_results_verify");
        } else {
          queryClient.invalidateQueries("verify_data");
          queryClient.invalidateQueries("travelerResults");
        }
      } catch (error) {
        toast.error("Error while retesting Flash Test");
        processErrorOnMutation(error, dispatch, history);
        setConfirmationDialogRetestOpen(false);
        setOpen(false);
        if (isVerification) {
          queryClient.invalidateQueries("procedure_results_verify");
        } else {
          queryClient.invalidateQueries("verify_data");
          queryClient.invalidateQueries("travelerResults");
        }
      }
    }
  };

  const onProcedureSelected = async (
    event: React.ChangeEvent<{ value: unknown }>,
  ) => {
    const selectedProcedureId = event.target.value as number;

    try {
      var data = await mutateProcedure({
        authAxios,
        procedure_id: id,
        selected_procedure_id: selectedProcedureId,
      });

      setFlashValues(data);
    } catch (err) {
      toast.error("No data found");
    }
  };

  const isChartLoading =
    isCustomCurve && (isLoadingCustomView || isFetchingCustomView);

  return (
    <>
      <TravelerModalButton
        disposition={disposition}
        name={name}
        handleClose={handleClose}
        open_notes={open_notes}
        has_notes={has_notes}
        type="iv"
        isComments={isComments}
        onOpenNotes={onOpenNotes}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth={true}
        maxWidth={"xl"}
      >
        <DialogTitle id="scroll-dialog-title">
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={6}>
              <Typography variant="h6">
                {`Flash Test Data Review - ${name}`};
              </Typography>
            </Grid>
            {!isCustomCurve && (
              <Grid item xs={2}>
                <TextField
                  id="chart-select"
                  select
                  label="Chart Type"
                  value={chartType}
                  onChange={handleChartType}
                  fullWidth
                >
                  <MenuItem value={1}>Curve</MenuItem>
                  <MenuItem value={2}>Scatter</MenuItem>
                </TextField>
              </Grid>
            )}

            {isCustomCurve && (
              <Grid item xs={2}>
                <TextField
                  id="custom-chart-select"
                  select
                  label="Custom Chart Type"
                  value={ivchartType}
                  onChange={handleChartType}
                  fullWidth
                >
                  <MenuItem value="fitted_curve">Fitted Curve</MenuItem>
                  <MenuItem value="fitted_scatter">Fitted Scatter</MenuItem>
                  
                  <MenuItem value="raw_scatter">Raw Scatter</MenuItem>
                </TextField>
              </Grid>
            )}
            <Grid item xs={1}>
              <Typography variant="body2" display="inline">
                Flag Result:
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <ThreadedCreator
                id={id}
                noteType={3}
                model={"procedure"}
                invalidate={[""]}
                typeable={false}
              />
            </Grid>
            <Grid item xs={1}>
              <VisualizerNotesModal
                procedureId={id}
                name={`Flash Test Review - ${name}`}
              />
            </Grid>
            <Grid item xs={1}>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent dividers={true}>
          {viewErrorMessage ? (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              style={{ minHeight: 300 }}
            >
              <Grid item>
                <Typography variant="h6" color="error" align="center">
                  {viewErrorMessage}
                </Typography>
              </Grid>
              {showRetestOnError && permission && (
                  <Grid item>
                    <Button
                      variant="contained"
                      style={theme.btnError}
                      disabled={getTheme()}
                      onClick={() => setConfirmationDialogRetestOpen(true)}
                    >
                      Retest
                    </Button>
                  </Grid>
                )}
            </Grid>
          ) : (
            <>
              {isChartLoading && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    zIndex: 100,
                  }}
                >
                  <CircularProgress />
                </div>
              )}
              {viewData && Object.keys(viewData).length !== 0 && (
                <Grid
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="center"
                  spacing={4}
                >
                  <Grid item xs={3}>
                    <AssetNameViewer procedureResults={viewData} />
                  </Grid>

                  <Grid xs={3}>
                    <Typography variant="h6">
                      All Verification Checks Passed :{" "}
                      {viewData.automated_verification
                        ? viewData.automated_verification
                        : "N/A"}{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <>
                      {viewData?.avg_deviation !== undefined &&
                        viewData?.avg_deviation !== null && (
                          <Typography variant="h6">
                            Average Deviation Value Across the Workorder:{" "}
                            {viewData.avg_deviation}
                          </Typography>
                        )}
                    </>
                  </Grid>
                  {viewData.is_flash_pdf && (
                    <Grid item xs={3}>
                      <MuiLink
                        onClick={() => setPdfOpen(true)}
                        style={{ cursor: "pointer" }}
                      >
                        Click Here for More Info
                      </MuiLink>
                    </Grid>
                  )}

                  <Grid item xs={6}>
                    <TableContainer>
                      {viewData.procedure_definition_name ===
                      "I-V Curve at STC (Rear)" ? (
                        <Typography>
                          Bifaciality nameplate:{" "}
                          {viewData?.unit_type.module_property.bifacial_pmax ??
                            "N/A"}
                        </Typography>
                      ) : null}
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>PMP</TableCell>
                            <TableCell>VOC</TableCell>
                            <TableCell>VMP</TableCell>
                            <TableCell>ISC</TableCell>
                            <TableCell>IMP</TableCell>
                            <TableCell>FF</TableCell>
                            <TableCell>Irradiance</TableCell>
                            <TableCell>Temperature</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {viewData.procedure_definition_name ===
                          "I-V Curve at LIC (Front)" ? (
                            <TableRow>
                              <TableCell>STC Measured</TableCell>
                              <TableCell>
                                {viewData?.stc_measured?.pmp ?? "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.stc_measured?.voc ?? "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.stc_measured?.vmp ?? "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.stc_measured?.isc ?? "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.stc_measured?.imp ?? "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.stc_measured?.ff ?? "N/A"}
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          ) : viewData.procedure_definition_name ===
                            "I-V Curve at STC (Rear)" ? (
                            <TableRow>
                              <TableCell>STC Nameplate</TableCell>
                              <TableCell>
                                {viewData?.unit_type.module_property
                                  .nameplate_pmax ?? "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.unit_type.module_property.voc ??
                                  "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.unit_type.module_property.vmp ??
                                  "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.unit_type.module_property.isc ??
                                  "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.unit_type.module_property.imp ??
                                  "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.unit_type.module_property.ff ??
                                  "N/A"}
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          ) : (
                            <TableRow>
                              <TableCell>STC Nameplate</TableCell>
                              <TableCell>
                                {
                                  viewData.unit_type.module_property
                                    .nameplate_pmax
                                }
                              </TableCell>
                              <TableCell>
                                {viewData.unit_type.module_property.voc}
                              </TableCell>
                              <TableCell>
                                {viewData.unit_type.module_property.vmp}
                              </TableCell>
                              <TableCell>
                                {viewData.unit_type.module_property.isc}
                              </TableCell>
                              <TableCell>
                                {viewData.unit_type.module_property.imp}
                              </TableCell>
                              <TableCell>
                                {viewData.unit_type.module_property.ff}
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          )}

                          {viewData.procedure_definition_name ===
                          "I-V Curve at LIC (Front)" ? (
                            <TableRow>
                              <TableCell>STC Scaled</TableCell>

                              <TableCell>
                                {viewData?.stc_scaled?.pmp != null
                                  ? (
                                      viewData.stc_scaled.pmp * multiplier
                                    ).toFixed(2)
                                  : "N/A"}
                              </TableCell>

                              <TableCell>
                                {viewData?.stc_scaled?.voc != null
                                  ? (
                                      viewData.stc_scaled.voc * multiplier
                                    ).toFixed(2)
                                  : "N/A"}
                              </TableCell>

                              <TableCell>
                                {viewData?.stc_scaled?.vmp != null
                                  ? (
                                      viewData.stc_scaled.vmp * multiplier
                                    ).toFixed(2)
                                  : "N/A"}
                              </TableCell>

                              <TableCell>
                                {viewData?.stc_scaled?.isc != null
                                  ? (
                                      viewData.stc_scaled.isc * multiplier
                                    ).toFixed(2)
                                  : "N/A"}
                              </TableCell>

                              <TableCell>
                                {viewData?.stc_scaled?.imp != null
                                  ? (
                                      viewData.stc_scaled.imp * multiplier
                                    ).toFixed(2)
                                  : "N/A"}
                              </TableCell>

                              <TableCell>
                                {viewData?.stc_scaled?.ff != null
                                  ? (
                                      viewData.stc_scaled.ff * multiplier
                                    ).toFixed(2)
                                  : "N/A"}
                              </TableCell>

                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          ) : viewData.procedure_definition_name ===
                            "I-V Curve at STC (Rear)" ? (
                            <TableRow>
                              <TableCell>Scaled Nameplate</TableCell>
                              <TableCell>
                                {viewData?.scaled_nameplate.pmp ?? "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.scaled_nameplate.voc ?? "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.scaled_nameplate.vmp ?? "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.scaled_nameplate.isc ?? "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.scaled_nameplate.imp ?? "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.scaled_nameplate.ff ?? "N/A"}
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          ) : (
                            <TableRow>
                              <TableCell>Scaled Nameplate</TableCell>
                              <TableCell>
                                {(
                                  viewData.unit_type.module_property
                                    .nameplate_pmax * multiplier
                                ).toFixed(2)}
                              </TableCell>
                              <TableCell>
                                {(
                                  viewData.unit_type.module_property.voc *
                                  multiplier
                                ).toFixed(2)}
                              </TableCell>
                              <TableCell>
                                {(
                                  viewData.unit_type.module_property.vmp *
                                  multiplier
                                ).toFixed(2)}
                              </TableCell>
                              <TableCell>
                                {(
                                  viewData.unit_type.module_property.isc *
                                  multiplier
                                ).toFixed(2)}
                              </TableCell>
                              <TableCell>
                                {(
                                  viewData.unit_type.module_property.imp *
                                  multiplier
                                ).toFixed(2)}
                              </TableCell>
                              <TableCell>
                                {(
                                  viewData.unit_type.module_property.ff *
                                  multiplier
                                ).toFixed(2)}
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          )}

                          <TableRow>
                            <TableCell>Measurement Results</TableCell>
                            <TableCell>
                              {viewData.flash_values.Pmp?.toFixed(2)}
                            </TableCell>
                            <TableCell>
                              {viewData.flash_values.Voc?.toFixed(2)}
                            </TableCell>
                            <TableCell>
                              {viewData.flash_values.Vmp?.toFixed(2)}
                            </TableCell>
                            <TableCell>
                              {viewData.flash_values.Isc?.toFixed(2)}
                            </TableCell>
                            <TableCell>
                              {viewData.flash_values.Imp?.toFixed(2)}
                            </TableCell>
                            <TableCell>
                              {viewData.flash_values.ff?.toFixed(2)}
                            </TableCell>
                            <TableCell>
                              {viewData.flash_values.Irradiance?.toFixed(2)}
                            </TableCell>
                            <TableCell>
                              {viewData.flash_values.Temperature?.toFixed(2)}
                            </TableCell>
                          </TableRow>
                          {viewData.procedure_definition_name ===
                            "I-V Curve at STC (Rear)" && (
                            <TableRow>
                              <TableCell>Measured bifaciality</TableCell>
                              <TableCell>
                                {viewData.measured_bifaciality.pmp}
                              </TableCell>
                              <TableCell>
                                {viewData.measured_bifaciality.voc}
                              </TableCell>
                              <TableCell>
                                {viewData.measured_bifaciality.vmp}
                              </TableCell>
                              <TableCell>
                                {viewData.measured_bifaciality.isc}
                              </TableCell>
                              <TableCell>
                                {viewData.measured_bifaciality.imp}
                              </TableCell>
                              <TableCell>
                                {viewData.measured_bifaciality.ff}
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          )}

                          {viewData.procedure_definition_name ===
                          "I-V Curve at LIC (Front)" ? (
                            <TableRow>
                              <TableCell>Deviation from STC Scaled</TableCell>

                              <TableCell>
                                {viewData?.stc_scaled?.pmp != null &&
                                viewData?.flash_values?.Pmp != null &&
                                viewData?.iv_curves?.[0]?.multiplier != null
                                  ? deviation(
                                      viewData.stc_scaled.pmp,
                                      viewData.flash_values.Pmp,
                                      viewData.iv_curves[0].multiplier,
                                    ) + "%"
                                  : "N/A"}
                              </TableCell>

                              <TableCell>
                                {viewData?.stc_scaled?.voc != null &&
                                viewData?.flash_values?.Voc != null &&
                                viewData?.iv_curves?.[0]?.multiplier != null
                                  ? deviation(
                                      viewData.stc_scaled.voc,
                                      viewData.flash_values.Voc,
                                      viewData.iv_curves[0].multiplier,
                                    ) + "%"
                                  : "N/A"}
                              </TableCell>

                              <TableCell>
                                {viewData?.stc_scaled?.vmp != null &&
                                viewData?.flash_values?.Vmp != null &&
                                multiplier != null
                                  ? deviation(
                                      viewData.stc_scaled.vmp,
                                      viewData.flash_values.Vmp,
                                      multiplier,
                                    ) + "%"
                                  : "N/A"}
                              </TableCell>

                              <TableCell>
                                {viewData?.stc_scaled?.isc != null &&
                                viewData?.flash_values?.Isc != null &&
                                multiplier != null
                                  ? deviation(
                                      viewData.stc_scaled.isc,
                                      viewData.flash_values.Isc,
                                      multiplier,
                                    ) + "%"
                                  : "N/A"}
                              </TableCell>

                              <TableCell>
                                {viewData?.stc_scaled?.imp != null &&
                                viewData?.flash_values?.Imp != null &&
                                multiplier != null
                                  ? deviation(
                                      viewData.stc_scaled.imp,
                                      viewData.flash_values.Imp,
                                      multiplier,
                                    ) + "%"
                                  : "N/A"}
                              </TableCell>

                              <TableCell>
                                {viewData?.stc_scaled?.ff != null &&
                                viewData?.flash_values?.ff != null &&
                                multiplier != null
                                  ? deviation(
                                      viewData.stc_scaled.ff,
                                      viewData.flash_values.ff,
                                      multiplier,
                                    ) + "%"
                                  : "N/A"}
                              </TableCell>

                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          ) : viewData.procedure_definition_name ===
                            "I-V Curve at STC (Rear)" ? (
                            <TableRow>
                              <TableCell>
                                Deviation from Scaled Nameplate
                              </TableCell>
                              <TableCell>
                                {viewData?.scaled_nameplate?.pmp != null &&
                                viewData?.flash_values?.Pmp != null
                                  ? deviationforIVcurveRear(
                                      viewData.scaled_nameplate.pmp,
                                      viewData.flash_values.Pmp,
                                    ) + "%"
                                  : "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.scaled_nameplate?.voc != null &&
                                viewData?.flash_values?.Voc != null
                                  ? deviationforIVcurveRear(
                                      viewData.scaled_nameplate.voc,
                                      viewData.flash_values.Voc,
                                    ) + "%"
                                  : "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.scaled_nameplate?.vmp != null &&
                                viewData?.flash_values?.Vmp != null
                                  ? deviationforIVcurveRear(
                                      viewData.scaled_nameplate.vmp,
                                      viewData.flash_values.Vmp,
                                    ) + "%"
                                  : "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.scaled_nameplate?.isc != null &&
                                viewData?.flash_values?.Isc != null
                                  ? deviationforIVcurveRear(
                                      viewData.scaled_nameplate.isc,
                                      viewData.flash_values.Isc,
                                    ) + "%"
                                  : "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.scaled_nameplate?.imp != null &&
                                viewData?.flash_values?.Imp != null
                                  ? deviationforIVcurveRear(
                                      viewData.scaled_nameplate.imp,
                                      viewData.flash_values.Imp,
                                    ) + "%"
                                  : "N/A"}
                              </TableCell>
                              <TableCell>
                                {viewData?.scaled_nameplate?.ff != null &&
                                viewData?.flash_values?.ff != null
                                  ? deviationforIVcurveRear(
                                      viewData.scaled_nameplate.ff,
                                      viewData.flash_values.ff,
                                    ) + "%"
                                  : "N/A"}
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          ) : (
                            <TableRow>
                              <TableCell>
                                Deviation from Scaled Nameplate
                              </TableCell>
                              <TableCell>
                                {deviation(
                                  viewData.unit_type.module_property
                                    .nameplate_pmax,
                                  viewData.flash_values.Pmp,
                                  viewData.iv_curves[0].multiplier,
                                )}
                                %
                              </TableCell>
                              <TableCell>
                                {deviation(
                                  viewData.unit_type.module_property.voc,
                                  viewData.flash_values.Voc,
                                  viewData.iv_curves[0].multiplier,
                                )}
                                %
                              </TableCell>
                              <TableCell>
                                {deviation(
                                  viewData.unit_type.module_property.vmp,
                                  viewData.flash_values.Vmp,
                                  multiplier,
                                )}
                                %
                              </TableCell>
                              <TableCell>
                                {deviation(
                                  viewData.unit_type.module_property.isc,
                                  viewData.flash_values.Isc,
                                  multiplier,
                                )}
                                %
                              </TableCell>
                              <TableCell>
                                {deviation(
                                  viewData.unit_type.module_property.imp,
                                  viewData.flash_values.Imp,
                                  multiplier,
                                )}
                                %
                              </TableCell>
                              <TableCell>
                                {deviation(
                                  viewData.unit_type.module_property.ff,
                                  viewData.flash_values.ff,
                                  multiplier,
                                )}
                                %
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          )}
                          <TableRow>
                            <Grid item xs={6}>
                              <FormControl
                                style={{
                                  margin: theme.spacing(1),
                                  minWidth: 300,
                                }}
                              >
                                <InputLabel id="demo-simple-select-helper-label">
                                  Select Previous Procedure
                                </InputLabel>
                                <Select
                                  
                                  onChange={onProcedureSelected}
                                >
                                  {previousProcedure.map(
                                    (availableProcedures: any) => (
                                      <MenuItem value={availableProcedures.id}>
                                        {availableProcedures.name}
                                      </MenuItem>
                                    ),
                                  )}
                                </Select>
                              </FormControl>
                            </Grid>
                          </TableRow>
                          {preFlashValues.flash_values ? (
                            <TableRow>
                              <TableCell>Deviation</TableCell>
                              <TableCell>
                                {deviationPreMeasurement(
                                  preFlashValues.flash_values.Pmp,
                                  viewData.flash_values.Pmp,
                                  viewData.iv_curves[0].multiplier,
                                )}
                                %
                              </TableCell>
                              <TableCell>
                                {deviationPreMeasurement(
                                  preFlashValues.flash_values.Voc,
                                  viewData.flash_values.Voc,
                                  viewData.iv_curves[0].multiplier,
                                )}
                                %
                              </TableCell>
                              <TableCell>
                                {deviationPreMeasurement(
                                  preFlashValues.flash_values.Vmp,
                                  viewData.flash_values.Vmp,
                                  multiplier,
                                )}
                                %
                              </TableCell>
                              <TableCell>
                                {deviationPreMeasurement(
                                  preFlashValues.flash_values.Isc,
                                  viewData.flash_values.Isc,
                                  multiplier,
                                )}
                                %
                              </TableCell>
                              <TableCell>
                                {deviationPreMeasurement(
                                  preFlashValues.flash_values.Imp,
                                  viewData.flash_values.Imp,
                                  multiplier,
                                )}
                                %
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          ) : (
                            <div></div>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>

                  <Grid item xs={6}>
                    {viewData && charts.length > 0 ? renderChart() : null}
                  </Grid>

                  <Grid item xs={8} />
                  {permission && (
                    <>
                      <Grid item xs={2}>
                        <Button
                          variant="contained"
                          style={theme.btnError}
                          disabled={getTheme()}
                          onClick={() => setConfirmationDialogRetestOpen(true)}
                        >
                          Retest
                        </Button>
                      </Grid>
                      {disposition === "Requires Review" && (
                        <Grid item xs={2}>
                          <Button
                            variant="contained"
                            style={theme.btnNew}
                            onClick={() =>
                              setConfirmationDialogApproveOpen(true)
                            }
                          >
                            Approve
                          </Button>
                        </Grid>
                      )}
                    </>
                  )}
                </Grid>
              )}
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={1} />

            <Grid item xs={10} alignItems="center">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={flagChecked}
                    onChange={() => {
                      setFlagDialog(true);
                    }}
                    name="autoCheck"
                    color="primary"
                    disabled={getTheme()}
                  />
                }
                label="Final Result"
              />
            </Grid>
            <Grid item xs={1}>
              <Button onClick={handleClose} color="primary">
                Close
              </Button>
            </Grid>
          </Grid>
        </DialogActions>

        <ConfirmationDialog
          id="IV-review-retest"
          keepMounted
          open={confirmationDialogRetestOpen}
          title="IV Review Retest Confirmation"
          content="Are you sure that you want to retest this IV Review?"
          onCancel={() => setConfirmationDialogRetestOpen(false)}
          onSubmit={() => submitVerification(false)}
        />
        <ConfirmationDialog
          id="iv-review-approve"
          keepMounted
          open={confirmationDialogApproveOpen}
          title="IV Review Approval Confirmation"
          content="Are you sure that you want to approve this IV Review?"
          onCancel={() => setConfirmationDialogApproveOpen(false)}
          onSubmit={() => submitVerification(true)}
        />

        <ConfirmationDialog
          id="flag-update"
          keepMounted
          open={flagDialog}
          title="Approval Confirmation"
          content="Please confirm whether the selected result is Correct?"
          onCancel={() => setFlagDialog(false)}
          onSubmit={() => submitFlagUpdate()}
        />
      </Dialog>

      <Dialog
        open={Pdfopen}
        onClose={() => setPdfOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>{fileName}</DialogTitle>
        <DialogContent style={{ height: "80vh", padding: 0 }}>
          {pdfUrl ? (
            <iframe
              src={viewerUrl}
              width="100%"
              height="100%"
              style={{ border: "none" }}
              title="PDF Preview"
            />
          ) : (
            <Typography>No PDF available</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDownload} color="primary">
            Download
          </Button>
          <Button onClick={() => setPdfOpen(false)} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
